export default __webpack_public_path__ + "static/media/triviagreen.5b180d2c.svg";